import { createStore, useStore as baseUseStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";

export const key = Symbol("picc");
export const store = createStore({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(state) {
        return {
          openId: state.openId,
          userInfo: state.userInfo,
          code: state.code,
        };
      },
    }),
  ],
  state,
  mutations,
  actions,
});

export function useStore() {
  return baseUseStore(key);
}
